import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Box,
  Typography,
  MenuItem,
} from "@mui/material";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";
import { Get_Null_Country_Schools } from "../../../Misc/api/Get_Null_Country_Schools";
import { Get_Null_School_Or_Country_Attendees } from "../../../Misc/api/Get_Null_School_Or_Country_Attendees";
import { Get_Non_Null_School_Attendees_School_IDS } from "../../../Misc/api/Get_Non_Null_School_Attendees_School_IDS";

function SchoolToHubSpotTODO() {
  const { logout } = StaffuseAuth();

  const [Attendees, setAttendees] = useState([]);
  useEffect(() => {
    Get_Non_Null_School_Attendees_School_IDS(setAttendees, 100000, 0, logout);
  }, []);
  console.log("Attendees");
  console.log(Attendees);

  function handleGoToAttendeeSchoolAssigner(e) {
    e.preventDefault();
    window.open(`/Staff/AssignSchoolToHubSpot`, "_blank");
  }

  return (
    <>
      {Attendees.length > 0 ? (
        <Container maxWidth="sm">
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { m: 1, width: "25ch" },
            }}
            noValidate
            autoComplete="off"
          >
            Schools ready to be assigned to a HubSpot Account:{" "}
            {Attendees.length}
          </Box>
          <br></br>
          <button onClick={(e) => handleGoToAttendeeSchoolAssigner(e)}>
            Go To
          </button>
          <br></br>
          <br></br>
        </Container>
      ) : (
        <> </>
      )}
    </>
  );
}

export default SchoolToHubSpotTODO;
